"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b;
    return (vue_1.openBlock(), vue_1.createElementBlock("div", {
        class: vue_1.normalizeClass(["dialog-item", ((_a = _ctx.env) === null || _a === void 0 ? void 0 : _a.isH5) ? 'dialog-item-h5' : 'dialog-item-web'])
    }, [
        vue_1.withDirectives(vue_1.createElementVNode("ul", {
            class: vue_1.normalizeClass(["dialog-item-list", ((_b = _ctx.env) === null || _b === void 0 ? void 0 : _b.isH5) ? 'dialog-item-list-h5' : 'dialog-item-list-web'])
        }, [
            ((_ctx.message.type === _ctx.types.MSG_FILE ||
                _ctx.message.type === _ctx.types.MSG_VIDEO ||
                _ctx.message.type === _ctx.types.MSG_IMAGE) &&
                !_ctx.env.isH5)
                ? (vue_1.openBlock(), vue_1.createElementBlock("li", {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.openMessage(_ctx.message)); })
                }, [
                    vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.$t("TUIChat.打开")), 1)
                ]))
                : vue_1.createCommentVNode("", true),
            (_ctx.message.type === _ctx.types.MSG_TEXT)
                ? (vue_1.openBlock(), vue_1.createElementBlock("li", {
                    key: 1,
                    onClick: _cache[1] || (_cache[1] = function ($event) { return (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.copy)); })
                }, [
                    vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.$t("TUIChat.复制")), 1)
                ]))
                : vue_1.createCommentVNode("", true),
            (_ctx.message.status === 'success')
                ? (vue_1.openBlock(), vue_1.createElementBlock("li", {
                    key: 2,
                    onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.forward)); })
                }, [
                    vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.$t("TUIChat.转发")), 1)
                ]))
                : vue_1.createCommentVNode("", true),
            (_ctx.message.status === 'success')
                ? (vue_1.openBlock(), vue_1.createElementBlock("li", {
                    key: 3,
                    onClick: _cache[3] || (_cache[3] = function ($event) { return (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.reference)); })
                }, [
                    vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.$t("TUIChat.引用")), 1)
                ]))
                : vue_1.createCommentVNode("", true),
            (_ctx.message.status === 'success')
                ? (vue_1.openBlock(), vue_1.createElementBlock("li", {
                    key: 4,
                    onClick: _cache[4] || (_cache[4] = function ($event) { return (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.reply)); })
                }, [
                    vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.$t("TUIChat.回复")), 1)
                ]))
                : vue_1.createCommentVNode("", true),
            (_ctx.message.time &&
                _ctx.message.time > new Date().getTime() / 1000 - _ctx.msg_back_time * 60 &&
                _ctx.message.flow === 'out' &&
                _ctx.message.status === 'success' &&
                _ctx.message.type !== _ctx.types.MSG_CUSTOM)
                ? (vue_1.openBlock(), vue_1.createElementBlock("li", {
                    key: 5,
                    onClick: _cache[5] || (_cache[5] = function ($event) { return (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.revoke)); })
                }, [
                    vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.$t("TUIChat.撤回")), 1)
                ]))
                : vue_1.createCommentVNode("", true),
            (_ctx.message.status === 'success')
                ? (vue_1.openBlock(), vue_1.createElementBlock("li", {
                    key: 6,
                    onClick: _cache[6] || (_cache[6] = function ($event) { return (_ctx.handleMessage(_ctx.message, _ctx.constant.handleMessage.delete)); })
                }, [
                    vue_1.createElementVNode("span", null, vue_1.toDisplayString(_ctx.$t("TUIChat.删除")), 1)
                ]))
                : vue_1.createCommentVNode("", true)
        ], 2), [
            [vue_1.vShow, _ctx.showToolList]
        ])
    ], 2));
}
exports.render = render;
